<template>
  <div>
    <c-preloader v-if="isLoading" :isLoading="isLoading" bgcolor="rgb(58 42 79)"/>
    <c-nav/>
    <div class="page-content-container">
      <router-view></router-view>
    </div>
    <c-footer/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import cNav from '@/components/Nav.vue'
import cPreloader from '@/components/Preloader.vue'
import cFooter from '@/components/Footer.vue'

export default {
  components: {
    cNav,
    cPreloader,
    cFooter
  },
  computed: {
    ...mapState({
      isLoading: state => state.preloader.isLoading
    })
  }
}
</script>
